import { EXTERNAL_APP_BASE_URL } from 'utils/app-links'

/** Consent line under the checkout button (trial start). */
export const TermsNote = () => (
	<p className="font-grotesk text-[12px] leading-[18px] text-t-gray-checkout text-center">
		By starting your trial, you agree to our{' '}
		<a
			href={`${EXTERNAL_APP_BASE_URL}/terms-of-service`}
			target="_blank"
			rel="noreferrer"
			className="font-medium text-t-email-blue hover:underline"
		>
			Terms of Service
		</a>
	</p>
)
